import { useState } from 'preact/hooks';
import { useApi } from '../../hooks/useApi.js';
import { useAuth } from '../../hooks/useAuth.jsx';
import { Button } from '../../components/Button.jsx';
import { NewBookModal } from './NewBookModal.jsx';

const KIND_META = {
  pantone:  { label: 'Pantone',  color: '#00B4D8' },
  designer: { label: 'Designer', color: '#FF8A4C' },
  custom:   { label: 'Custom',   color: '#A18AF5' },
};

const BookCard = ({ book }) => {
  const meta = KIND_META[book.kind] ?? KIND_META.custom;
  return (
    <a
      href={`/ink-books/${book.id}`}
      class="block rounded-lg border border-border-subtle bg-bg-card p-5 transition hover:border-border-strong hover:bg-bg-hover focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
    >
      <div class="mb-2 flex items-center gap-2">
        <span
          class="block rounded-full"
          style={{ background: meta.color, width: 9, height: 9 }}
          aria-hidden="true"
        />
        <span
          class="text-[11px] font-semibold uppercase tracking-eyebrow"
          style={{ color: meta.color }}
        >
          {meta.label}
        </span>
      </div>
      <h3 class="m-0 mb-1 font-serif text-xl font-medium text-text-primary">
        {book.name}
      </h3>
      <p class="m-0 text-[13px] font-medium text-text-tertiary">
        {book.inkCount} {book.inkCount === 1 ? 'ink' : 'inks'} saved
      </p>
    </a>
  );
};

export const InkBooksIndexPage = () => {
  const { data: books, loading, error, refetch } = useApi('/ink-books');
  const { user } = useAuth();
  const [newOpen, setNewOpen] = useState(false);
  const isAdmin = user?.role === 'admin';

  return (
    <div>
      <section class="mb-8 flex items-start justify-between gap-4">
        <div>
          <p class="eyebrow mb-1.5" style={{ color: '#00B4D8' }}>Ink Books</p>
          <h1 class="m-0 mb-1.5 text-[34px] leading-[1.18] tracking-tight text-text-primary">
            Pantone &amp; designer libraries
          </h1>
          <p class="m-0 text-sm text-text-secondary">
            Each book holds inks and their per-printer mixes. Inks are created
            automatically when you star a match in the Converter — or you can add
            them manually.
          </p>
        </div>
        {isAdmin && (
          <Button variant="secondary" onClick={() => setNewOpen(true)} class="shrink-0">
            + New book
          </Button>
        )}
      </section>

      {loading && (
        <p class="text-sm text-text-tertiary">Loading…</p>
      )}
      {error && (
        <p class="text-sm font-semibold text-ink-magenta">
          Failed to load books: {error.message}
        </p>
      )}
      {books && (
        <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {books.map((b) => <BookCard key={b.id} book={b} />)}
        </div>
      )}

      <NewBookModal
        open={newOpen}
        onClose={() => setNewOpen(false)}
        onCreated={() => { setNewOpen(false); refetch(); }}
      />
    </div>
  );
};
